"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.SENDING_BUTTON_TEXT = exports.DEFAULT_SUBMIT_BUTTON_TEXT = void 0;
var classnames_1 = __importDefault(require("classnames"));
var mobx_1 = require("mobx");
var submit_page_footer_1 = __importDefault(require("@hikakaku/shared/components/estimate_form/common/submit_page_footer"));
exports.DEFAULT_SUBMIT_BUTTON_TEXT = '無料査定を申し込む';
exports.SENDING_BUTTON_TEXT = '送信中...';
var SubmitPageFooterStore = /** @class */ (function () {
    function SubmitPageFooterStore(props) {
        var _this = this;
        this.component = submit_page_footer_1.default;
        this.submitButtonText = exports.DEFAULT_SUBMIT_BUTTON_TEXT;
        this.isSubmitButtonEnabled = true;
        this.prepareSubmit = function () {
            _this.submitButtonText = exports.SENDING_BUTTON_TEXT;
        };
        this.handleClickPrevButton = function (event) {
            event.stopPropagation();
            event.preventDefault();
            _this.onClickPrevButton();
        };
        this.handleClickSubmitButton = props.onClickSubmitButton;
        this.onClickPrevButton = props.onClickPrevButton;
        if (props.submitButtonText) {
            this.submitButtonText = props.submitButtonText;
        }
    }
    Object.defineProperty(SubmitPageFooterStore.prototype, "submitButtonClassNames", {
        get: function () {
            return (0, classnames_1.default)("estimateForm-SubmitPageFooter_SubmitButton", { "estimateForm-SubmitPageFooter_SubmitButton": !this.isSubmitButtonEnabled });
        },
        enumerable: false,
        configurable: true
    });
    __decorate([
        mobx_1.observable,
        __metadata("design:type", Object)
    ], SubmitPageFooterStore.prototype, "submitButtonText", void 0);
    __decorate([
        mobx_1.observable,
        __metadata("design:type", Object)
    ], SubmitPageFooterStore.prototype, "isSubmitButtonEnabled", void 0);
    __decorate([
        mobx_1.computed,
        __metadata("design:type", String),
        __metadata("design:paramtypes", [])
    ], SubmitPageFooterStore.prototype, "submitButtonClassNames", null);
    __decorate([
        mobx_1.action,
        __metadata("design:type", Object)
    ], SubmitPageFooterStore.prototype, "prepareSubmit", void 0);
    return SubmitPageFooterStore;
}());
exports.default = SubmitPageFooterStore;
